import VimmiPI from 'vimmi-player-integration/dist/vimmi-player-integration.cjs';

let vimmiPI = new VimmiPI();
export default vimmiPI;